import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Contacto() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Contacto - VaciadoPro Barcelona | Presupuesto Gratis Vaciado Pisos';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Contacta con VaciadoPro Barcelona para tu presupuesto gratuito. Teléfono, WhatsApp y formulario de contacto. Respuesta inmediata para vaciado de pisos.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'contacto vaciado Barcelona, presupuesto vaciado Barcelona, teléfono vaciado pisos, WhatsApp vaciado Barcelona');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/contacto`);
    }

    // Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contacto - VaciadoPro Barcelona",
      "description": "Página de contacto para solicitar presupuesto de vaciado de pisos en Barcelona",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/contacto`,
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "VaciadoPro Barcelona",
        "telephone": "+34 123 456 789",
        "email": "info@vaciadopro.com",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Barcelona",
          "addressRegion": "Cataluña",
          "addressCountry": "ES"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 41.3851,
          "longitude": 2.1734
        },
        "openingHours": "Mo-Su 08:00-20:00",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+34 123 456 789",
          "contactType": "customer service",
          "availableLanguage": ["Spanish", "Catalan"]
        }
      }
    });
    document.head.appendChild(schemaScript);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Contacta con nosotros
              <span className="block text-green-600 text-2xl md:text-3xl mt-2">
                (Respuesta inmediata)
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              ¿Necesitas vaciar un piso en Barcelona? Contacta ahora y recibe tu presupuesto 
              gratuito en menos de 2 horas. Atendemos 24/7. Conoce más sobre 
              <a href="/empresa" className="text-green-600 hover:text-green-700 font-medium ml-1 mr-1">
                nuestra empresa
              </a>
              y consulta todos 
              <a href="/servicios" className="text-green-600 hover:text-green-700 font-medium ml-1">
                nuestros servicios especializados
              </a>.
            </p>
            
            {/* Direct CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <Button 
                href="https://wa.me/34690220944?text=Hola, necesito información sobre vaciado de piso en Barcelona" 
                variant="primary" 
                size="lg"
                className="flex items-center gap-3 bg-green-600 hover:bg-green-700"
                target="_blank"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Enviar WhatsApp
              </Button>
              <Button 
                href="tel:+34690220944" 
                variant="secondary" 
                size="lg"
                className="flex items-center gap-3 bg-blue-600 text-white hover:bg-blue-700"
              >
                <i className="ri-phone-line text-xl"></i>
                Llamar Ahora
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            
            {/* Contact Form */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">
                Formulario de contacto
              </h2>
              <form className="space-y-6" data-readdy-form id="contacto-vaciado">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-2">
                    Nombre
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="Tu nombre completo"
                  />
                </div>
                
                <div>
                  <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2">
                    Teléfono <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="+34 666 777 888"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="tu@email.com"
                  />
                </div>
                
                <div>
                  <label htmlFor="mensaje" className="block text-sm font-medium text-gray-700 mb-2">
                    Mensaje
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                    placeholder="Describe tu necesidad de vaciado (tipo de inmueble, ubicación, urgencia...). Si tienes dudas, consulta nuestras preguntas frecuentes."
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-1">
                    Máximo 500 caracteres. 
                    <a href="/faq" className="text-green-600 hover:text-green-700 font-medium ml-1">
                      Ver preguntas frecuentes
                    </a>
                  </p>
                </div>
                
                <div>
                  <label htmlFor="archivos" className="block text-sm font-medium text-gray-700 mb-2">
                    Fotos/Vídeo (Opcional)
                  </label>
                  <input
                    type="file"
                    id="archivos"
                    name="archivos"
                    multiple
                    accept="image/*,video/*"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  />
                  <p className="text-sm text-gray-500 mt-1">
                    Envía fotos o vídeo para una valoración más precisa
                  </p>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Enviar Consulta
                </button>
              </form>
            </div>

            {/* Business Information */}
            <div className="space-y-8">
              
              {/* NAP Information */}
              <div className="bg-white rounded-xl shadow-lg p-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">
                  Información de contacto
                </h2>
                
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-building-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1">VaciadoPro Barcelona</h3>
                      <p className="text-gray-600">Especialistas en vaciado de pisos</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-blue-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1">Dirección</h3>
                      <p className="text-gray-600">
                        Carrer de Balmes, 123<br />
                        08008 Barcelona, España
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1">Teléfono</h3>
                      <a href="tel:+34690220944" className="text-green-600 hover:text-green-700 font-medium">
                        +34 690 22 09 44
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-purple-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1">Email</h3>
                      <a href="mailto:info@vaciadoprobarcelona.com" className="text-purple-600 hover:text-purple-700 font-medium">
                        info@vaciadoprobarcelona.com
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-orange-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800 mb-1">Horarios</h3>
                      <div className="text-gray-600 space-y-1">
                        <p>Lunes - Viernes: 08:00 - 20:00</p>
                        <p>Sábado: 09:00 - 18:00</p>
                        <p>Domingo: Emergencias</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Benefits */}
              <div className="bg-green-50 rounded-xl p-8">
                <h3 className="text-xl font-bold text-gray-800 mb-4">
                  ¿Por qué contactar con nosotros?
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">Respuesta en menos de 2 horas</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">
                      Presupuesto gratuito y sin compromiso - 
                      <a href="/servicios" className="text-green-600 hover:text-green-700 font-medium ml-1">
                        Ver servicios
                      </a>
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">
                      Atención profesional y personalizada - 
                      <a href="/empresa" className="text-green-600 hover:text-green-700 font-medium ml-1">
                        Conoce nuestro equipo
                      </a>
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-check-line text-green-600"></i>
                    <span className="text-gray-700">
                      Disponibilidad 24/7 para emergencias - 
                      <a href="/faq" className="text-green-600 hover:text-green-700 font-medium ml-1">
                        Ver FAQ
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Maps */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">
              Nuestra ubicación
            </h2>
            <div className="bg-gray-200 rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2993.0234567890123!2d2.1734!3d41.3851!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDIzJzA2LjQiTiAywrAwMCcyNC4yIkU!5e0!3m2!1ses!2ses!4v1234567890123!5m2!1ses!2ses"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación de VaciadoPro Barcelona"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Emergency CTA */}
      <section className="py-16 bg-red-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            ¿Necesitas un vaciado urgente?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Para casos urgentes, contáctanos directamente por teléfono. 
            Atendemos emergencias las 24 horas. Consulta nuestros 
            <a href="/servicios" className="text-green-200 hover:text-white font-medium ml-1 mr-1">
              servicios de emergencia
            </a>
            y conoce más sobre 
            <a href="/empresa" className="text-green-200 hover:text-white font-medium ml-1">
              nuestro equipo profesional
            </a>.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              href="tel:+34690220944" 
              variant="secondary" 
              size="lg"
              className="!bg-white !text-red-600 hover:!bg-gray-100 border-2 border-white flex items-center gap-3"
            >
              <i className="ri-phone-line text-xl"></i>
              Llamada de Emergencia
            </Button>
            <Button 
              href="https://wa.me/34690220944?text=URGENTE: Necesito vaciado inmediato en Barcelona" 
              variant="outline" 
              size="lg"
              className="border-white text-white hover:!bg-white hover:!text-red-600 flex items-center gap-3"
              target="_blank"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp Urgente
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
